module.exports = __webpack_public_path__ + "img/rock-big-02.16ab5328.png";